"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _Icon = require("@gogame/ui/Icon");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var AutosizeColumns = /*#__PURE__*/(0, _react.forwardRef)(function (_, ref) {
  var apiRef = (0, _xDataGridPro.useGridApiContext)();
  var handleAutofitColumnWidth = function handleAutofitColumnWidth() {
    var _apiRef$current;
    var columnsLookup = (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 ? void 0 : _apiRef$current.state.columns.lookup;
    if (!columnsLookup) {
      return;
    }
    var autosizeColumns = Object.keys(columnsLookup).reduce(function (acc, column) {
      var _columnsLookup$column = columnsLookup[column],
        field = _columnsLookup$column.field,
        resizable = _columnsLookup$column.resizable;
      return field && resizable ? [].concat(_toConsumableArray(acc), [field]) : acc;
    }, []);
    apiRef.current.autosizeColumns({
      includeHeaders: false,
      includeOutliers: true,
      expand: false,
      outliersFactor: 1,
      columns: autosizeColumns
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.AutofitWidthIcon, {}),
    tooltip: 'Autofit column width',
    onClick: handleAutofitColumnWidth,
    ref: ref
  });
});
AutosizeColumns.displayName = 'AutosizeColumns';
var _default = exports["default"] = AutosizeColumns;